import { ChangeDetectionStrategy, Component, Input, ViewEncapsulation } from '@angular/core';
import { IForumPostEdit } from '../fi-forum';
import { ICommentModel } from '../../fi-comments/fi-comments';

@Component({
    selector: 'fi-forum-post-view-container',
    template: `
        <div class="fi-container">
            <div class="fi-header">
                <div class="fi-header-actions">
                    <fi-button-back-new />
                </div>
                <div class="fi-header-text">
                    {{ 'forum.viewing_forum_post' | fiAppText }}
                </div>
            </div>
            <div class="fi-content" #contentElement>
                <fi-forum-post-view
                    [forumPost]="forumPost"
                    [comments]="comments"
                    [isEditMode]="isEditMode"
                    [scrollToCommentId]="commentId"
                />
            </div>
        </div>
    `,
    styleUrls: ['./fi-forum-post-view-container.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-forum-post-view-container' },
    standalone: false,
})
export class FiForumPostViewContainerComponent {
    @Input() forumPost: IForumPostEdit;
    @Input() comments: ICommentModel[];
    @Input() commentId: number;
    @Input() isEditMode: boolean;
}
